import { useState, useEffect, useRef } from 'react';

const IntroAnimation = ({ onComplete }) => {
  const videoRef = useRef(null);
  const [fadeOut, setFadeOut] = useState(false);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    const handleEnded = () => {
      setFadeOut(true);
      setTimeout(() => onComplete(), 1000);
    };

    video.addEventListener('ended', handleEnded);

    // Fallback: if video doesn't load or takes too long, skip after 15s
    const fallbackTimer = setTimeout(() => {
      setFadeOut(true);
      setTimeout(() => onComplete(), 1000);
    }, 15000);

    return () => {
      video.removeEventListener('ended', handleEnded);
      clearTimeout(fallbackTimer);
    };
  }, [onComplete]);

  const handleSkip = () => {
    setFadeOut(true);
    setTimeout(() => onComplete(), 600);
  };

  return (
    <div
      data-testid="intro-animation"
      className={`fixed inset-0 z-[9999] bg-black flex items-center justify-center transition-opacity duration-1000 ${
        fadeOut ? 'opacity-0 pointer-events-none' : 'opacity-100'
      }`}
    >
      <video
        ref={videoRef}
        autoPlay
        muted
        playsInline
        preload="auto"
        className="w-full h-full object-cover"
        style={{ imageRendering: 'high-quality' }}
      >
        <source
          src="https://customer-assets.emergentagent.com/job_89ca90eb-2af0-4196-930e-afe44457c0d6/artifacts/fn7xui0g_2026-03-12T18-37-28_a_breathtaking.mp4"
          type="video/mp4"
        />
      </video>

      <button
        data-testid="skip-intro-btn"
        onClick={handleSkip}
        className="absolute bottom-8 right-8 px-6 py-2 text-sm text-white/70 hover:text-white border border-white/30 hover:border-white/60 rounded-full backdrop-blur-sm bg-black/20 transition-all duration-300 tracking-wider uppercase"
      >
        Skip
      </button>
    </div>
  );
};

export default IntroAnimation;
